export const mappedProductTypes = [{ value: 'Booking', label: 'Booking' },
  { value: 'Ticket', label: 'Ticket' },
  { value: 'Membership', label: 'Membership' },
  { value: 'Class', label: 'Class' }];